import { render, staticRenderFns } from "./ContractedWorksItem.vue?vue&type=template&id=46e53d30&"
import script from "./ContractedWorksItem.vue?vue&type=script&lang=js&"
export * from "./ContractedWorksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports